import { createApp } from 'vue'
//导入app根组件
import App from './App.vue'
import router from './router'
import store from './store'

 //导入ant design
import Antd from 'ant-design-vue' 
import 'ant-design-vue/dist/reset.css'

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';    //日期插件月份显示中文
import datePicker  from 'ant-design-vue/es/date-picker/locale/zh_CN';
dayjs.locale('zh-cn');





createApp(App).use(Antd).use(store).use(router).mount('#app')
